import { useQuery } from '@tanstack/react-query'
import { customInstance } from 'lib/api-instance'

export type HomeConfigCarouselItem = {
  id: number
  bookId: number
  bookTitle: string
  bookAuthor: string | null
  bookSlug: string | null
  bookImage: string | null
  position: number
  bookHasAudioBook?: boolean | null
}

export type HomeConfigCarousel = {
  id: number
  slug: string
  title: string
  type: 'auto' | 'manual'
  enabled: boolean
  position: number
  items?: HomeConfigCarouselItem[]
}

export type HomeConfigBanner = {
  id: number
  title: string
  imageUrl: string | null
  mobileImageUrl: string | null
  linkUrl: string | null
  active: boolean
  position: number
  startsAt: string | null
  endsAt: string | null
}

export type HomeConfig = {
  carousels: HomeConfigCarousel[]
  banners: HomeConfigBanner[]
  settings: Record<string, string | null>
}

export const HOME_CONFIG_QUERY_KEY = ['home-config']

const EMPTY_HOME_CONFIG: HomeConfig = {
  carousels: [],
  banners: [],
  settings: {}
}

const fetchHomeConfig = async (): Promise<HomeConfig> => {
  const response = await customInstance<{ data: HomeConfig }>(
    '/api-arvore/home-config'
  )
  const data = response.data ?? (response as unknown as HomeConfig)

  return {
    carousels: data.carousels ?? [],
    banners: data.banners ?? [],
    settings: data.settings ?? {}
  }
}

export const useHomeConfig = (enabled = true) => {
  const { data, isLoading } = useQuery({
    queryKey: HOME_CONFIG_QUERY_KEY,
    queryFn: fetchHomeConfig,
    enabled,
    retry: 0,
    staleTime: 5 * 60 * 1000
  })

  return { config: data ?? EMPTY_HOME_CONFIG, isLoading: enabled && isLoading }
}
